var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTestDrive = function SvgIconTestDrive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1937_91940",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1937_91940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.975 17L12 15.175L16.025 17L16.4 16.625L12 5.99997L7.6 16.625L7.975 17ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1166 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6166 2.2625 9.31664 2.7875 8.09997C3.3125 6.8833 4.025 5.82497 4.925 4.92497C5.825 4.02497 6.88333 3.31247 8.1 2.78747C9.31667 2.26247 10.6167 1.99997 12 1.99997C13.3833 1.99997 14.6833 2.26247 15.9 2.78747C17.1167 3.31247 18.175 4.02497 19.075 4.92497C19.975 5.82497 20.6875 6.8833 21.2125 8.09997C21.7375 9.31664 22 10.6166 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1166 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z",
    fill: "#05072C"
  }))));
};
export default SvgIconTestDrive;